import React from 'react';
import { userEvents } from '../../utils/analytics';
import './SocialButtons.css';

const SocialButtons = () => {
  const handleSocialClick = (platform) => {
    userEvents.buttonClick(`social_${platform}`, 'newsletter');
    const urls = {
      twitter: 'https://twitter.com/readthetape_',
      linkedin: 'https://linkedin.com/company/readthetape',
      email: 'mailto:intern@mg.readthetape.xyz'
    };
    window.open(urls[platform], '_blank');
  };

  return (
    <div className="social-buttons">
      <button 
        className="social-button"
        onClick={() => handleSocialClick('email')}
        aria-label="Email us"
      >
        <img src="/assets/mail.svg" alt="Email" className="social-icon" />
      </button>
      <button 
        className="social-button"
        onClick={() => handleSocialClick('twitter')}
        aria-label="Follow on Twitter"
      >
        <img src="/assets/twitter.svg" alt="Twitter" className="social-icon" />
      </button>
    </div>
  );
};

export default SocialButtons;
